import _classCallCheck from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var Datalayer = /*#__PURE__*/function () {
  function Datalayer(event, property) {
    _classCallCheck(this, Datalayer);

    _defineProperty(this, "_event", void 0);

    _defineProperty(this, "_property", void 0);

    this._event = event;
    this._property = property;
  }

  _createClass(Datalayer, [{
    key: "property",
    get: function get() {
      return this._property;
    },
    set: function set(value) {
      this._property = value;
    }
  }, {
    key: "event",
    get: function get() {
      return this._event;
    },
    set: function set(value) {
      this._event = value;
    }
  }]);

  return Datalayer;
}();

export default Datalayer;